export default {
    AUSPOST: 'AUSPOST',
    ARAMEX: 'ARAMEX',
    SHERPA: 'SHERPA',
    CLICKCOLLECT: 'CLICKCOLLECT'
};
